module.exports = __webpack_public_path__ + "img/lunbo.c3005567.png";